import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import { CKLeverantorService } from "~app/features/forsaljning/ckleverator/services/ckleverantor.service";
import { ISearchMottagningsplatsQueryResult } from "~app/features/forsaljning/mottagningsplats/mottagningsplats.models";
import { MottagningsplatsService } from "~app/features/forsaljning/mottagningsplats/mottagningsplats.service";
@Injectable({
    providedIn: "root"
})
export class SkapaArbetsorderService {
    private readonly ckLeverantorService = inject(CKLeverantorService);
    private readonly mottagningsplatsService = inject(MottagningsplatsService);

    hamtaMottagningsplatser(): Observable<ISearchMottagningsplatsQueryResult[]> {

        return this.mottagningsplatsService.searchMottagningsplatserWithLagerplatser({ aktiv: true });
    }

    hamtaCkLeverantorer(): Observable<any> {
        return this.ckLeverantorService.searchCKLeverantor({ aktiv:true });
    }
}
